import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import noImage from "../../Assets/Image/admin/user.png";
import { IMG_URL } from "../../Services/Api";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { Calendar } from "lucide-react";
import {
  addCampaignApi,
  getCampaignDetails,
  getCategoryList,
  listUserRole,
  updateCampaign,
} from "../../Services/ApiServices";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import back from "../../Assets/Image/admin/back.png";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Circles } from "react-loader-spinner";
import moment from "moment/moment";

export default function AddCampaign() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [img, setImg] = useState("");
  const [images, setImage] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [formvalues, setFormvalues] = useState({});
  const [categoryData, setCategoryData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [userRoleData, setUserRoleData] = useState([]);
  const [descriptionData, setDescriptionData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const today = new DateObject()
    .setHour(0)
    .setMinute(0)
    .setSecond(0)
    .setMillisecond(0);

  const handleFile = (e) => {
    setImg(e.target.files[0]);
    let profileImage = URL.createObjectURL(e.target.files[0]);
    setImage(profileImage);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormvalues({ ...formvalues, [name]: value });
  };

  const handleCategoryList = () => {
    setLoader(true);
    getCategoryList()
      .then((res) => {
        const data = res.data.data;
        setCategoryData(data);
        setLoader(false);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setLoader(false);
      });
  };

  const handleUserRoleList = () => {
    listUserRole()
      .then((res) => {
        const data = res.data.data;
        setUserRoleData(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
      });
  };

  const HtmlContent = ({ htmlString }) => {
    const sanitizedHtml = DOMPurify.sanitize(htmlString);
    const style = `
                ol {
                  margin: 0;
                  padding: 0;
                  list-style-type: decimal; /* Numbering */
                  padding-left: 20px; /* Adjust left padding as needed */
                }
                ul {
                  margin: 0;
                  padding: 0;
                  list-style-type: disc; /* Bullets */
                  padding-left: 20px; /* Adjust left padding as needed */
                }
                li {
                  margin: 0;
                  padding: 0;
                  line-height: 1.5;
                }
                a {
                  color: blue;
                }
              `;

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `<style>${style}</style>${sanitizedHtml}`,
        }}
      />
    );
  };

  HtmlContent.propTypes = {
    htmlString: PropTypes.string.isRequired,
  };

  const handleEditorChange = (content) => {
    const updatedContent = content.replace(
      /<a(?![^>]*\btarget="_blank")/g,
      '<a target="_blank"'
    );
    setDescriptionData(updatedContent);
  };

  useEffect(() => {
    handleCategoryList();
    handleUserRoleList();
  }, []);

  const handleGetProductDetails = () => {
    let obj = {
      id: id,
    };

    getCampaignDetails(obj)
      .then((res) => {
        const data = res.data.data;
        console.log("data", data);
        setFormvalues(data);
        const existingImages = data.image;
        setImage(existingImages);
        setStartDate(data.start_date);
        setEndDate(data.end_date);
        setDescriptionData(data.description);
        setLoader(false);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    if (id) {
      handleGetProductDetails();
    }
  }, [id]);

  const handleChangeStartDate = (date) => {
    if (date) {
      const formattedDate = moment(date.toDate()).format("YYYY-MM-DD");
      setStartDate(formattedDate);
      setEndDate("");
    }
  };

  const handleChangeEndDate = (date) => {
    if (date) {
      const formattedDate = moment(date.toDate()).format("YYYY-MM-DD");
      setEndDate(formattedDate);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);
    const formData = new FormData();
    formData.append("title", formvalues.title);
    formData.append("category_id", formvalues.category_id);
    formData.append("role_id", formvalues.role_id);
    formData.append("start_date", startDate);
    formData.append("end_date", endDate);
    formData.append("description", descriptionData);

    if (id) {
      formData.append("id", id);
    }

    if (img) {
      formData.append("capaign_img", img);
    }

    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    if (!images) {
      toast.error("Please Select Image");
      setIsLoading(false);
    } else if (!descriptionData) {
      toast.error("Please enter description");
      setIsLoading(false);
    } else {
      if (id) {
        updateCampaign(formData)
          .then((res) => {
            toast.success("Campaign updated successfully!");
            navigate("/campaign");
            setIsLoading(false);
          })
          .catch((err) => {
            if (err?.response?.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err?.response?.data?.message);
            }
            setIsLoading(false);
          });
      } else {
        addCampaignApi(formData)
          .then((res) => {
            toast.success("Campaign created successfully!");
            navigate("/campaign");
            setIsLoading(false);
          })
          .catch((err) => {
            if (err?.response?.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err?.response?.data?.message);
            }
            setIsLoading(false);
          });
      }
    }
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex items-center cursor-pointer mb-4">
        <img
          src={back}
          onClick={() => {
            navigate("/campaign");
          }}
          className="w-4"
          alt=""
        />
        <p
          onClick={() => {
            navigate("/campaign");
          }}
          className="text-base font-medium ms-3 p-0"
        >
          Go back
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        className="md:p-7 p-4 bg-white rounded-[16px]"
      >
        <div>
          <label
            htmlFor="regularImage"
            className="lg:text-base text-sm font-medium"
          >
            Campaign Image:
          </label>
          <div className="p-5 bg-white mt-1 border-2 rounded-2xl shadow-sm border-slate-200/60 dark:border-darkmode-400">
            <div className="relative sm:w-96 w-full h-48 mx-auto cursor-pointer image-fit">
              {images ? (
                <img
                  className="drop-shadow-md object-contain rounded-2xl w-full h-full"
                  alt="Profile"
                  src={images.startsWith("blob:") ? images : IMG_URL + images}
                />
              ) : (
                <div className="flex items-center justify-center w-full h-full">
                  <p>No Image</p>
                </div>
              )}
            </div>
            <div className="relative mx-auto flex justify-center mt-5 cursor-pointer">
              <button variant="primary" type="button" className="w-72">
                Upload Image
              </button>
              <input
                type="file"
                accept="image/*"
                className="absolute top-0 left-0 w-full h-full opacity-0"
                // required={Type == 0}
                onChange={handleFile}
              />
            </div>
          </div>
        </div>

        <div className="my-4">
          <label
            htmlFor="regular-Title"
            className="lg:text-base text-sm font-medium"
          >
            Title
          </label>
          <input
            id="regular-Title"
            className="border-2 mt-1 px-4 py-3 rounded-md w-full outline-[#e1c595]"
            name="title"
            value={formvalues.title}
            onChange={(e) => handleChange(e)}
            type="text"
            // required={Type == 0}
            placeholder="Enter title"
          />
        </div>

        <div className="flex md:flex-row flex-col my-4 gap-x-5">
          <div className="w-full">
            <label
              htmlFor="category_id"
              className="lg:text-base text-sm font-medium"
            >
              Select Category
            </label>

            <select
              name="category_id"
              required
              value={formvalues.category_id || ""}
              onChange={handleChange}
              className="select-arrow-hidden w-full mt-1 outline-[#e1c595] border-2 px-4 py-3 rounded-md"
            >
              <option label="Select Category"></option>
              {categoryData.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.category_name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="w-full md:mt-0 mt-4">
            <label
              htmlFor="role_id"
              className="lg:text-base text-sm font-medium"
            >
              Select User Role
            </label>
            <select
              name="role_id"
              value={formvalues.role_id || ""}
              onChange={handleChange}
              required
              className="select-arrow-hidden w-full mt-1 outline-[#e1c595] border-2 px-4 py-3 rounded-md"
            >
              <option label="Select role"></option>
              {userRoleData.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.role_name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="flex md:flex-row flex-col my-4 gap-x-5">
          <div className="w-full">
            <label
              htmlFor="start_date"
              className="lg:text-base text-sm font-medium w-full"
            >
              Start Date
            </label>
            <br />
            <div className="relative w-full mt-1">
              <DatePicker
                selected={startDate}
                onChange={(date) => date && handleChangeStartDate(date)}
                selectsStart
                value={startDate}
                startDate={startDate}
                endDate={endDate}
                onKeyDown={(e) => e.preventDefault()}
                inputClass="w-full border border-[#E5E7EB] px-4 py-3 rounded-lg focus:ring-2 focus:ring-gray-400 focus:outline-none"
                placeholder="Select Date"
                placeholderText="dd-mm-yyyy"
                dateFormat="dd-MM-yyyy"
                editable={false}
                minDate={today}
              />
              <div className="absolute right-4 top-6 transform -translate-y-1/2 cursor-pointer">
                <Calendar className="text-gray-500" size={20} />
              </div>
            </div>
          </div>

          <div className="w-full md:mt-0 mt-4">
            <label
              htmlFor="end_date"
              className="lg:text-base text-sm font-medium"
            >
              End Date
            </label>
            <br />
            <div className="relative w-full mt-1">
              <DatePicker
                selected={endDate}
                onChange={(date) => date && handleChangeEndDate(date)}
                selectEnd
                startDate={startDate}
                value={endDate}
                endDate={endDate}
                // required={Type == 0}
                onKeyDown={(e) => e.preventDefault()}
                inputClass="w-full border border-[#E5E7EB] px-4 py-3 rounded-lg focus:ring-2 focus:ring-gray-400 focus:outline-none"
                placeholder="Select Date"
                placeholderText=" dd-mm-yyyy"
                dateFormat="dd-MM-yyyy"
                minDate={
                  startDate ? new DateObject(startDate).add(1, "day") : today
                }
                editable={false}
              />
              <div className="absolute right-4 top-6 transform -translate-y-1/2 cursor-pointer">
                <Calendar className="text-gray-500" size={20} />
              </div>
            </div>
          </div>
        </div>

        <div className="my-4">
          <label
            htmlFor="regular-Description"
            className="lg:text-base text-sm font-medium"
          >
            Campaign Description
          </label>
          <div className="mt-1">
            <SunEditor
              setContents={descriptionData || ""}
              onChange={handleEditorChange}
              height="280px"
              setOptions={{
                buttonList: [
                  ["undo", "redo"],
                  ["fontSize"],
                  ["bold", "underline", "italic"],
                  ["fontColor", "hiliteColor"],
                  ["align", "list"],
                  ["link", "image"],
                ],
              }}
              name="my-editor"
              required
            />
          </div>
        </div>

        <div className="flex items-center justify-end mt-6">
          <button
            type="submit"
            disabled={isLoading}
            className="bg-[#00987C] text-white h-[45px] w-34 rounded-lg"
          >
            {isLoading ? (
              <div className="flex justify-center">
                <Circles
                  width={25}
                  height={25}
                  color="#fff"
                  ariaLabel="circles-loading"
                  wrapperStyle={{}}
                  visible={true}
                  wrapperClass=""
                />
              </div>
            ) : id ? (
              "Update"
            ) : (
              "Add"
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
